import {Directive, DirectiveBinding, h, render, nextTick} from 'vue';
import {OxdIcon} from '@ohrm/oxd';

const infoTooltipDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    if (!binding.value) return;

    // Ensure the component's root element is ready
    nextTick(() => {
      // Make parent relatively positioned if not already
      const parent = el.parentElement;
      if (!parent) return;
      const parentPosition = getComputedStyle(parent).position;
      if (parentPosition === 'static') {
        parent.style.position = 'relative';
      }

      // Create icon vnode
      const iconNode = h(OxdIcon, {
        name: 'info-circle-fill',
        title: binding.value,
        style: {
          position: 'absolute',
          top: '2px',
          right: '2px',
          cursor: 'pointer',
          fontSize: '11px',
          color: '#20516D',
        },
      });

      // Container for the icon
      const container = document.createElement('span');
      parent.appendChild(container);
      render(iconNode, container);
    });
  },
};

export default infoTooltipDirective;
